//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["configurationDataSize"],"GetConfigurationData",{R_:{configurationData:''}},0,0],[["geometryCount","geometryData"],"GetGeometryData",{},0,0]],[]];
SPLM.SketchOperationData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchOperationData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchOperationData.GeometryData = class{
    constructor(geometryTag,geometryString){
        this.geometryTag=geometryTag;this.geometryString=geometryString;}
    get Geometrytag(){return this.geometryTag}
    set Geometrytag(val){this.geometryTag = val}
    get Geometrystring(){return this.geometryString}
    set Geometrystring(val){this.geometryString = val}
};

export default SPLM;